import Vue from 'vue';

export default {
  state: {
    bills: [],
  },
  getters: {
    bills(state) {
      return state.bills;
    },
    bill: state => id => state.bills.find(item => item.id === id) || {},
  },
  mutations: {
    SET_BILLS(state, payload) {
      state.bills = payload;
    },
  },
  actions: {
    GET_BILLS(context, payload) {
      return Vue.axios.get(`filters/bills/${payload.customer_id}`).then((response) => {
        context.commit('SET_BILLS', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/bills.js